import { useEffect, useMemo, useState } from "react";
import { Sidebar } from "./Sidebar";
import { TeamTable } from "./TeamTable";
import { Users, User } from "lucide-react";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { ProfileSection } from "./ProfileSection";
import { useSearchParams } from "react-router-dom";
import { hasAdminPrivileges } from "@/zapi-frontend/shared/utils/permissions";
import { BuildingIcon } from "@phosphor-icons/react";
import { GeneralSection } from "./_GeneralSection";

export function SettingsPage() {
  const { role } = useMeStore();
  const isAdmin = hasAdminPrivileges(role);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") as "Team" | "Profile" | "General" | null;
  const [activeTab, setActiveTab] = useState<"Team" | "Profile" | "General">(initialTab || "Profile");

  const renderContent = useMemo(() => {
    if (activeTab === "Profile") return <ProfileSection />;
    if (activeTab === "General") return <GeneralSection />;

    return <TeamTable />;
  }, [activeTab]);

  const menuItems = {
    Account: [{ name: "Profile", icon: <User /> }],
    ...(isAdmin && {
      Organization: [
        { name: "General", icon: <BuildingIcon /> },
        { name: "Team", icon: <Users /> }
      ]
    })
  };

  function handleTabChange(tab: "Team" | "Profile") {
    setActiveTab(tab);
    setSearchParams({ tab });
  }

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab]);

  return (
    <div className="mx-auto mt-2 w-[calc(100%-16px)] h-[calc(100vh-72px)] grid grid-cols-[260px_1fr] bg-white">
      <Sidebar activeTab={activeTab} setActiveTab={handleTabChange} menuItems={menuItems} />
      <main className="overflow-y-auto py-[18px] px-[32px]">{renderContent}</main>
    </div>
  );
}
